 
import CADAvailableCourses from "../../components/CAD_Home/CAD_Available_Courses";
import CADCareerAdvantages from "../../components/CAD_Home/CAD_Career_Advantages";
import CADCourseDetails from "../../components/CAD_Home/CAD_Course_Details";
import CAD_FAQ from "../../components/CAD_Home/CAD_FAQ";
import CADHeroSection from "../../components/CAD_Home/CAD_Hero_Section";
import CADWhyFeesWorth from "../../components/CAD_Home/CAD_Why_FeesWorth";
import CADWhyLearn from "../../components/CAD_Home/CAD_Why_Learn";
import CourseEnquiryButton from "../../components/CAD_Home/CourseEnquiryButton";
import GetInTouch from "../../components/common/Contact/GetInTouch";
import PlaceMentRecord from "../../components/common/PlaceMent/PlaceMentRecord";
import SEO from "../../components/common/seo/SEO";
import cadCourseVideos from "../../data/ai_section/cadCourseVideos";
function CADAutomationPage() {




    return (
        <>

            <SEO
                title="CAD Automation Training | FeesWorth"

                description="Master CAD Automation and CAD Customization with practical training in SolidWorks, CATIA, Siemens NX and Autodesk Inventor. Learn programming, APIs, macros, add-ins and real-world CAD automation techniques."

                keywords="CAD Automation Course, CAD Automation Training, CAD Customization Course, CAD Customization Training, CAD API Training, CAD Automation, SolidWorks API, CATIA CAA, NX Open, Siemens NX Automation, Autodesk Inventor API"

                canonical="https://feesworth.com/cad-automation-training"
            />

            <CADHeroSection

                title="CAD Automation   & Customization Online Training"

                intro="Master CAD Automation and develop powerful solutions to automate repetitive engineering design tasks.
                Learn how to automate leading CAD & PLM platforms such as NX, CATIA, CREO, SolidWorks, Inventor, AutoCAD, Revit, Teamcenter and Windchill using programming, APIs, macros, add-ins, and CAD automation techniques."

                sections={[
                    {
                        title: "15 Years of Practical CAD Automation & Customization Training",
                        content: `Since 2012 FeesWorth has become a trusted name for both individual and corporate for CAD Automation & Customization training. Our CAD Automation Course covers practical customization concepts across Part Design, Assembly Design, and Drafting,
                    helping mechanical and design engineers to build customized CAD tools,
                    automate repetitive design tasks, create productivity-enhancing features, and develop solutions tailored to real-world engineering workflows.`
                    },
                    {
                        title: "Successfull Corporate Training",
                        content: `
                    We’ve successfully conducted specialized corporate training programs on cad customization & automation for leading global companies such as Molex, Valeo, Bradken, Mold Masters, Sacha Engineering and many more.
                    `
                    },
                    {
                        title: "4X to 5X Salary Growth",
                        content: `We have a proven track record of helping CAD professionals and design engineers transition from traditional design roles toward
                    higher-paying CAD customization and engineering software development careers.
                    Many of our students have seen their salaries increase from ₹0–10 LPA to ₹20–40 LPA after completing their training.`
                    },
                    {
                        title: "Proven Student Success Across Top Companies",
                        content: `
                    Our students are already placed in top-tier companies such as Honeywell, Autodesk, TCS, Cognizant, Tata Technologies,
                    L&T Technology Services, ITC Infotech, Tech Mahindra, Ford, Kennametal, and others.`
                    },

                ]}

            />



            <PlaceMentRecord />


            <CourseEnquiryButton
                courseName="CAD Automation Course"
                buttonText="Contact us"
            />

            <CADCourseDetails
                title="Complete Course Details"

                description="Everything you need to know about our CAD Automation Course — including practical automation training, real-world projects, and career opportunities — is explained through these sessions."

                featured={cadCourseVideos.featured}

                videos={cadCourseVideos.videos}
            />

            <CourseEnquiryButton
                courseName="CAD Automation Course"
                buttonText="Contact us"
            />

            <CADCareerAdvantages />

            <CADWhyLearn />

            <CADAvailableCourses />

            <CourseEnquiryButton
                courseName="CAD Automation Course"
                buttonText="Contact us"
            />


            <CADWhyFeesWorth />

            <CAD_FAQ />

            <GetInTouch />
        </>
    );
}

export default CADAutomationPage;